import React from 'react';
import { EmailBlock, HtmlBlockContent } from '../types';

interface HtmlBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const HtmlBlock: React.FC<HtmlBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as HtmlBlockContent;

  const style: React.CSSProperties = {
    padding: '10px',
    ...block.styles
  };

  return (
    <div style={style}>
      <div
        dangerouslySetInnerHTML={{ __html: content.html || '<p>Custom HTML</p>' }}
        className="min-h-[50px]"
      />
    </div>
  );
};
